import { takeLatest, fork, put, call } from "redux-saga/effects";
import { SUPPLY_CHAIN_ACTIONS } from "constants/actions";
import CompanyService from "services/company-service";
import {
    fetchedCaseSupplyChainDetails,
    failedFetchCaseSupplyChainDetails,
    updatedCaseSupplyChainDetails,
    failedUpdateCaseSupplyChainDetails,
    fetchedCaseSupplyChainFinancials,
    failedFetchCaseSupplyChainFinancials
} from "store/actions";

function* fetchSupplyChainRecord({ payload: { caseId } }) {
    try {
        const { data, error } = yield call(
            CompanyService.getSupplyChainData,
            caseId
        );
        if (!error) {
            yield put(fetchedCaseSupplyChainDetails(caseId, data));
        } else {
            yield put(failedFetchCaseSupplyChainDetails(caseId, error));
        }
    } catch(error) {
        yield put(failedFetchCaseSupplyChainDetails(caseId, error));
    }
}

function* updateSupplyChainRecord({ payload: { caseId, data } }) {
    try {
        const { data: newData, error } = yield call(
            CompanyService.updateSupplyChainData,
            caseId,
            data
        );
        if (!error) {
            yield put(updatedCaseSupplyChainDetails(caseId, newData));
        } else {
            yield put(failedUpdateCaseSupplyChainDetails(caseId, error));
        }
    } catch(error) {
        yield put(failedUpdateCaseSupplyChainDetails(caseId, error));
    }
}

function* fetchSupplyChainFinancials({ payload: { caseId } }) {
    try {
        const { data, error } = yield call(
            CompanyService.getSupplyChainFinancials,
            caseId
        );
        if (!error) {
            yield put(fetchedCaseSupplyChainFinancials(caseId, data));
        } else {
            put(failedFetchCaseSupplyChainFinancials(caseId, error));
        }
    } catch(error) {
        put(failedFetchCaseSupplyChainFinancials(caseId, error));
    }
}

export default fork(function*() {
    yield takeLatest(
        SUPPLY_CHAIN_ACTIONS.FETCH_CASE_SUPPLY_CHAIN_DETAILS,
        fetchSupplyChainRecord
    );
    yield takeLatest(
        SUPPLY_CHAIN_ACTIONS.UPDATE_CASE_SUPPLY_CHAIN_DETAILS,
        updateSupplyChainRecord
    );
    yield takeLatest(
        SUPPLY_CHAIN_ACTIONS.FETCH_CASE_SUPPLY_CHAIN_FINANCIALS,
        fetchSupplyChainFinancials
    );
});
